import styled from 'styled-components';

/** Wrapper 12 col, mobile 8 */
export const SectionGrid = styled.section<{
  $max?: number;
}>`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  column-gap: 4rem;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoint.width1080}) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 1.6rem;
    max-width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    column-gap: 1.4rem;
  }
`;

export const GridSpan = styled.div<{ start?: number; span?: number }>`
  grid-column: ${({ start = 1, span = 12 }) => `${start} / span ${span}`};
  width: 100%;

  & > * {
    max-width: 100% !important;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    grid-column: 1 / -1;
  }
`;

export const CenterStack = styled.div`
  display: grid;
  justify-items: center;
  text-align: center;

  /* Forțează center pe textele interne, chiar dacă componenta pune left */
  & h1,
  & h2,
  & h3,
  & h4,
  & p,
  & ul,
  & li,
  & div {
    text-align: center !important;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    padding: 1rem;
  }
`;
export const PageContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
`;

export const GridContainer = styled.div<{
  oneColumn?: boolean;
  isAuthorized?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ oneColumn }) => (oneColumn ? '1fr' : '1fr 1fr')};
  justify-items: center;
  align-items: center;
  gap: 2rem;

  margin: ${({ isAuthorized }) => (isAuthorized ? '4rem 0rem' : '2rem 0rem')};
  padding: ${({ isAuthorized }) => (isAuthorized ? '4rem 0rem' : '2rem 0rem')};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 2rem 0rem;
    position: relative;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 110rem;
  position: relative;
`;
